import { computed, Injectable, signal } from "@angular/core";
import { CurrencyPurchaseDto } from "../model/currency-purchase.model";
import { CurrencyPurchaseApi } from "../service/currency-purchase.api";
import { CurrencyPurchaseSelectionState } from "./currency-purchase.selection.state";
import { finalize, tap, throwError } from "rxjs";
import { CorpTranslateService } from "@corporate-tailwind/translation";
import { OrderApprovalRangeApi } from "../service/order-approval-range.api";
import { OrderApprovalRangeState } from "./order-approval-range.state";

@Injectable({ providedIn: 'root' })
export class CurrencyPurchaseState {
    private readonly _currencyPurchase = signal<CurrencyPurchaseDto | null>(null);
    private readonly _loading = signal<boolean>(true);
    private readonly _loadingCurrencyValue = signal<boolean>(false);
    private readonly _isAmountAlert = signal<boolean>(false);

    readonly currencyPurchase = this._currencyPurchase.asReadonly();
    readonly loading = this._loading.asReadonly();
    public readonly loadingCurrencyValue = this._loadingCurrencyValue.asReadonly();
    public readonly isAmountAlert = this._isAmountAlert.asReadonly();
  
    orderApprovalRange$ = computed(() => this._orderApprovalRangeState.selection());

  constructor(    
    private _currencyPurchaseApi: CurrencyPurchaseApi,
    private _orderApprovalRangeState: OrderApprovalRangeState,
    private _currencyPurchaseSelectionState: CurrencyPurchaseSelectionState,
    private _corpTranslateService: CorpTranslateService
  ) {
      this._corpTranslateService.attach(this._currencyPurchase);
  }

  init() {
    this._loading.set(true);

    this._currencyPurchaseApi.getDefault()
      .pipe(
        tap(() => this._loading.set(true)),
        finalize(() => this._loading.set(false))
      )
      .subscribe({
        next: currencyPurchase => {
          currencyPurchase = this._corpTranslateService.translate(currencyPurchase);

          this._currencyPurchase.set(currencyPurchase);
          //chargement de la selection
          this._currencyPurchaseSelectionState.load(currencyPurchase);
          //chargement OrderApprovalRangeDto
          this._orderApprovalRangeState.load();

          this._loading.set(false);
        },
        error: err => {
          console.error('Erreur lors du chargement utilisateur', err);
        }
      });
  }

  changeItem(item: CurrencyPurchaseDto) {
    this._loadingCurrencyValue.set(true);

    this._currencyPurchaseApi.changeItem(item)
      .pipe(
          tap(() => this._loadingCurrencyValue.set(true)),
          finalize(() => this._loadingCurrencyValue.set(false))
        )
      .subscribe({
        next: currencyPurchase => {

          this._currencyPurchase.update(current => {
            if (!current) return current;

            const isAmountAlert = this.updateIsAmountAlert(currencyPurchase.sourceAmount!);
            this._isAmountAlert.set(isAmountAlert);

            return {
              ...currencyPurchase
            };
          });

          
        },
        error: err => {
          console.error('Erreur api', err);
          return throwError(() => err);
        }
      });
  }

  patch(changes: Partial<CurrencyPurchaseDto>) {
    this._currencyPurchase.update(u => u ? { ...u, ...changes } : u);
  }

  updateIsAmountAlert(sourceAmount: number): boolean {

    const approvalRange = this.orderApprovalRange$();

    if(approvalRange){
        if(sourceAmount && sourceAmount>0  && approvalRange.minAmount && approvalRange.maxAmount){
            var isAlert = (sourceAmount < approvalRange.minAmount || sourceAmount > approvalRange.maxAmount);
            return isAlert;
        }
    }
    
    return true;
  }

}